import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { StyledSwitch } from '../../components/forms/Switch';
import { EditableList, RowItem } from '../../components/forms/EditableList';
import { EmailType } from './EditTripGroupForm';
import { EmailInput, FormInputWrapper } from '../../components/forms/Input';
import { testEmailAgainstRegex } from '../../lib/airframe/FormValidation';

const DivWrapper = styled.div`
  display: inline-flex;
  margin-right: 12px;
`;

const Margin = styled.div`
  margin-top: 25px;
  margin-bottom: 30px;
`;

type TripAlertEmailsProps = {
  emailData: EmailType[];
  setEmailData: React.Dispatch<React.SetStateAction<EmailType[]>>;
  isOverridden: boolean;
  setSaveDisabled: (disabled: boolean) => void;
};

export const TripAlertEmails: React.FC<TripAlertEmailsProps> = ({
  emailData,
  setEmailData,
  isOverridden,
  setSaveDisabled,
}) => {
  const [emailInputs, setEmailInputs] = useState<{ key: string; rowElement: JSX.Element }[]>([]);
  const getBlankItem = (): RowItem => ({
    key: uuidv4(),
    rowElement: (
      <>
        <DivWrapper>
          <FormInputWrapper>
            <EmailInput
              name={`email-${uuidv4()}`}
              id={`email-${uuidv4()}`}
              value=""
              onChange={() => {}}
              onError={(): void => {}}
            />
          </FormInputWrapper>
        </DivWrapper>
        <DivWrapper>
          <StyledSwitch
            text="Active"
            isDisabled={!isOverridden}
            on={true}
            onChange={() => {}}
          />
        </DivWrapper>
      </>
    ),
  });

  useEffect(() => {
    let hasError = false;
    // Generate list of of emails/active
    const list = emailData.map(element => {
      const key = element.key;
      const emailKey = `email-${key}`;

      // don't allow saving of invalid email addresses if they can edit the settings
      if (isOverridden && !testEmailAgainstRegex(element.emailAddress))
        hasError = true;

      return {
        key: key,
        rowElement: (
          <>
            <DivWrapper>
              <FormInputWrapper>
                <EmailInput
                  name={emailKey}
                  id={emailKey}
                  value={element.emailAddress}
                  onChange={e => {
                    emailChangeHandler(key, e.currentTarget.value);
                  }}
                  onError={(): void => {}}
                />
              </FormInputWrapper>
            </DivWrapper>
            <DivWrapper>
              <StyledSwitch
                text="Active"
                // id={`isActive-${key}`}
                isDisabled={!isOverridden}
                on={element.active}
                onChange={(val: boolean) => {
                  disableChangeHandler(key, val);
                }}
              />
            </DivWrapper>
          </>
        ),
      };
    });
    setEmailInputs(list);
    setSaveDisabled(hasError);
  }, [emailData]);

  const emailChangeHandler = (key: string, value: string) => {
    setEmailData(currentData =>
      currentData.map(item => {
        if (item.key === key) {
          item.emailAddress = value;
        }
        return item;
      }),
    );
  };
  const disableChangeHandler = (key: string, value: boolean) => {
    if (isOverridden) {
      setEmailData(currentData =>
        currentData.map(item => {
          if (item.key === key) {
            item.active = value;
          }
          return item;
        }),
      );
    }
  };

  return (
    <>
      <Margin>
        <h4>Agent Trip Alert Emails</h4>
        <EditableList
          itemList={emailInputs}
          getBlankItemData={getBlankItem}
          setListData={(data) => {
            const emailData = (Array.isArray(data) ? data : []).map(item => ({
              key: item.key,
              emailAddress: (item.rowElement as React.ReactElement).props.children[0].props.children.props.children.props.value as string,
              active: (item.rowElement as React.ReactElement).props.children[1].props.children.props.on as boolean
            }));
            setEmailData(emailData);
          }}
          isDisabled={!isOverridden}
        />
      </Margin>
    </>
  );
};
